import { render, staticRenderFns } from "./PriceProjects.vue?vue&type=template&id=22d8b62a&"
import script from "./PriceProjects.vue?vue&type=script&lang=js&"
export * from "./PriceProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports